<div class="toast-message type-{{data.type}}">
    <span>{{ data.message }}</span>
    <span class="sap-icon close-icon" (click)="dismiss()"></span>
</div>